import PrimaryButton from "./PrimaryButton";

const DialogBox = ({
  closeDialog,
  children,
  action,
  actionText,
  cancelText,
  actionDisabled,
  cancelDisabled,
  actionLoading,
  widthClass,
  noBlur,
  animate,
  closeOnOutsideClick,
  actionBgColor,
}) => {
  return (
    <div
      className={`fixed z-50 top-[4.1rem] left-0 w-full h-[80%] ${
        !noBlur && "backdrop-blur"
      } ${
        animate && "animate-enter_from_bottom"
      } flex justify-center items-center`}
      onClick={
        closeOnOutsideClick &&
        (() => {
          closeDialog();
        })
      }>
      <div
        className={`rounded-lg shadow-2xl border-2 flex flex-col items-center p-4 shrink-0 bg-white ${widthClass}`}>
        {children}
        <div className="mt-4 flex gap-2">
          {action && (
            <PrimaryButton
              disabled={actionDisabled}
              loading={actionLoading}
              text={actionText || "Done"}
              onClick={action}
              bgColor={actionBgColor}
            />
          )}

          <PrimaryButton
            disabled={cancelDisabled}
            text={cancelText || "Cancel"}
            onClick={closeDialog}
          />
        </div>
      </div>
    </div>
  );
};

export default DialogBox;
